// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from '../components/Frontend/Dashboard/Dashboard';
import { AccountListProvider } from '../context/AccountListContext';
import SuperAdminDashboard from '../components/Frontend/Dashboard/SuperAdminDashboard';
import AdminRoot from '../components/Frontend/Dashboard/AdminRoot';

export const dashboardRoutes = (
  <>
    <Route path="/dashboard" element={<MainLayout />}>
      <Route index element={
        <AccountListProvider>
          <Dashboard />
        </AccountListProvider>
      }
      />
    </Route>
    <Route path="/admin" element={<MainLayout />}>
      <Route index element={
        <AccountListProvider>
          <AdminRoot />
        </AccountListProvider>
      }
      />
    </Route>
  </>
);
